const isSameConversation = (a, b) => String(a?.id) === String(b?.id) && a?.platform === b?.platform;

export const isConversationInSelection = (conversation, selectedConversations = []) => (
  Array.isArray(selectedConversations)
  && selectedConversations.some((selectedConversation) => isSameConversation(selectedConversation, conversation))
);

export const getConversationActionTargets = (conversation, selectedConversations = []) => (
  isConversationInSelection(conversation, selectedConversations)
    ? selectedConversations
    : [conversation]
);

// Deja en la selección solo las conversaciones que siguen en la lista y refresca su agente y estado.
// Devuelve la misma referencia si no cambió nada, para no provocar renders.
export const syncSelectionWithConversations = (selectedConversations = [], conversations = []) => {
  if (!selectedConversations.length) return selectedConversations;

  let changed = false;
  const synced = selectedConversations.reduce((acc, selected) => {
    const current = conversations.find((conversation) => isSameConversation(conversation, selected));
    if (!current) {
      changed = true;
      return acc;
    }

    const currentStatusChat = Number(current.statusChat);
    const agentChanged = String(current.assignedAgent?.id ?? '') !== String(selected.assignedAgent?.id ?? '');
    if (agentChanged || currentStatusChat !== Number(selected.statusChat)) {
      changed = true;
      acc.push({ ...selected, assignedAgent: current.assignedAgent, statusChat: currentStatusChat });
    } else {
      acc.push(selected);
    }
    return acc;
  }, []);

  return changed ? synced : selectedConversations;
};

export const buildReadStatePayload = (conversations = []) => conversations.map((conversation) => ({
  id: conversation.id,
  platform: conversation.platform
}));

export const buildAssignAgentPayload = (conversations = [], agentValue) => {
  const newAgent = { id: agentValue };

  return conversations
    .filter((conversation) => Number(conversation?.assignedAgent?.id) !== Number(agentValue))
    .reduce((acc, conversation) => {
      acc.body.push({ id: conversation.id, platform: conversation.platform, newAgent });
      acc.options.push({ id: conversation.id, prevAgent: conversation.assignedAgent });
      return acc;
    }, { body: [], options: [] });
};

export const buildMessagingStatePayload = (conversations = [], statusChatValue) => {
  const targetStatusChat = Number(statusChatValue);

  return conversations
    .filter((conversation) => Number(conversation?.statusChat) !== targetStatusChat)
    .reduce((acc, conversation) => {
      acc.body.push({
        id: conversation?.id,
        platform: conversation?.platform,
        status_chat: targetStatusChat
      });
      acc.options.push({
        id: conversation?.id,
        status_chat: conversation?.statusChat
      });
      return acc;
    }, { body: [], options: [] });
};
